import { AppKey } from '@inno-sdks/files'
import { middlewareController } from 'shared/api/middlewareController'

export const filesApi = middlewareController.create.axiosInstance({
  baseURL: process.env.REACT_APP_CLUSTER_FILES_ENDPOINT
})

filesApi.interceptors.request.use(request => {
  request.headers['X-App-Key'] = AppKey.Desktop
  return request
})

// filesApi.interceptors.response.use(
//   response => response,
//   (error: AxiosError) => {
//     if (error.config?.skipInterceptor) {
//       return Promise.reject(error)
//     }

//     const status = error.response?.status
//     const toastId = Math.random().toString()

//     if (status === HttpStatusCodes.Forbidden) {
//       toast.error({
//         title: i18nextClusterFiles.t('authorization-failed.title'),
//         subTitle: i18nextClusterFiles.t('authorization-failed.subtitle'),
//         options: { toastId, ...toastDefaultOptions.options }
//       })
//     } else if (status === HttpStatusCodes.Unauthorized) {
//       toast.error({
//         title: i18nextClusterFiles.t('authentication-failed.title'),
//         subTitle: i18nextClusterFiles.t('authentication-failed.subtitle'),
//         options: { toastId, ...toastDefaultOptions.options }
//       })
//     }

//     return Promise.reject(error)
//   }
// )
